<template>
<div class="qualifiedModel">
  <div class="cont">
    <el-form :model="form" label-width="170px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="检定/校准结果上传：">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :http-request="myupload"
              :show-file-list="false"
              :accept="'image/*'"
              :before-upload="handleBeforeUpload"
            >
              <img v-if="imgURL" :src="imgURL" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div class="footer">
    <el-button type="primary" @click="submit">确认</el-button>
    <el-button @click="cancel">取消</el-button>
  </div>
</div>
</template>

<script>
import axios from '@/util/request';
import { FileUrl } from "@/api/depotApi";
export default {
  data() {
    return {
      uploadUrl: "/admin/sys-file/upload", //上传地址
      imgURL: "", //在线地址
      form: {},
    };
  },
  methods: {
    myupload(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.form.photo = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then(res => {
            that.imgURL = res.data;
          })
        }
        else {
          that.$message.error(res.msg);
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    handleBeforeUpload(file) {
      const isImage = file.type.includes("image");
      if (!isImage) {
        this.$message.error("上传文件类型必须是图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    submit() {
      this.$emit("qualified", this.form.photo);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
}
</script>

<style lang="less" scopde>
.qualifiedModel {
  width: 100%;
  .footer {
    clear: both;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar-uploader .el-upload {
    border: 2px solid #0090f0;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #74c8fe;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .avatar {
    width: 108px;
    height: 108px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/previewModel/components/qualifiedModel.vue